import Layout from "@/layouts/Layout.vue";
import itemsSearch from "@/views/items/search.vue";

import { UserPermissions } from "@/utils";

let searchRoute = {
  path: "/search",
  component: Layout,
  name: "Търсене на артикули ",
  redirect: "/search",
  hidden: true,
  meta: {
    actions: [UserPermissions.USER, UserPermissions.ADMIN],
  },
  children: [
    {
      path: "/search",
      name: "Търсене",
      component: itemsSearch,
      meta: {
        title: "Търсене",
        actions: [UserPermissions.USER, UserPermissions.ADMIN],
        icon: "mdi-clipboard-text-search-outline",
      },
      hidden: false
    }
  ]
}

export default searchRoute;